export const BETA_MODE = {
  enabled: false,
  skipValidation: false,
  allowSkipSteps: false,
  mockData: {
    client: {
      businessName: 'Test Business',
      contactName: 'Test User',
      email: 'test@example.com',
      phone: '+1234567890',
      address: '123 Test St'
    }
  }
};

export const isBetaMode = () => BETA_MODE.enabled;
export const canSkipSteps = () => BETA_MODE.enabled && BETA_MODE.allowSkipSteps;
